<template>
	<AppLayout
		:title="campaign.subject"
		:subtitle="trans('tools.campaigns.mails.recipients.title')"
		:return-url="route('tools.campaigns.instances.index', campaign.id)"
		:return-label="trans('tools.campaigns.mails.instances')"
	>
		<Pagination :resource="recipients"/>
		<Empty v-if="recipients.data.length === 0"/>
		<CardGrid v-else>
			<Card v-for="recipient in recipients.data" :key="`recipients-${recipient.id}`" :title="recipient.full_name" :subtitle="recipient.email"/>
		</CardGrid>
		<Pagination :resource="recipients"/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {type User} from '@/Types/User'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'

const props = defineProps<{
	campaign:Campaign,
	recipients:PaginatedModel<User>,
}>()

const recipients:Ref<PaginatedModel<User>> = ref(props.recipients)
</script>